export * from '@primeuix/themes/nora/fileupload';
export { default } from '@primeuix/themes/nora/fileupload';
